import { lazy } from 'react';

const VoucherPinImport = lazy(() => import('./VoucherPinImport'));

export default VoucherPinImport;
